[
  "ai.com",
  "accounting.com",
  "achievements.com",
  "admin.com",
  "allianz-trade.com",
  "app.com",
  "authentication.com",
  "chift.com",
  "chorus.com",
  "context-help.com",
  "debtors.com",
  "dunning.com",
  "ellisphere.com",
  "errors.com",
  "forms.com",
  "home.com",
  "import.com",
  "requests.com",
  "iso.com",
  "menu.com",
  "mobile.com",
  "placeholders.com"
]